<div class="!overflow-hidden w-full px-[5.208vw] pt-[2vh] lg:pt-[3vh] relative min-h-[93vh]">
      <div class="w-full flex items-center justify-end" *ngIf="showDemo">
            <app-theme></app-theme>
      </div>
      <app-header></app-header>
      <div class="w-full h-full lg:px-[1.562vw] mt-[3.703vh]">
            <app-question2></app-question2>
      </div>
</div>